var _a;
export var MaterialOriginType;
(function (MaterialOriginType) {
    MaterialOriginType["Generic"] = "Generic";
    MaterialOriginType["Manufacturer"] = "Manufacturer";
    MaterialOriginType["UserDefinedProduct"] = "UserDefinedProduct";
})(MaterialOriginType || (MaterialOriginType = {}));
export var RuMaterialOriginTypesSelectValues = [
    { label: 'Общий', value: MaterialOriginType.Generic },
    { label: 'Производитель', value: MaterialOriginType.Manufacturer },
    { label: 'Пользовательский продукт', value: MaterialOriginType.UserDefinedProduct },
];
export var MaterialTypeEnum;
(function (MaterialTypeEnum) {
    MaterialTypeEnum["MasonryAndSolid"] = "MasonryAndSolid";
    MaterialTypeEnum["Frame"] = "Frame";
    MaterialTypeEnum["PorousMaterials"] = "PorousMaterials";
    MaterialTypeEnum["SandwichPanel"] = "SandwichPanel";
    MaterialTypeEnum["GypsumBondedbBoards"] = "GypsumBondedbBoards";
    MaterialTypeEnum["WoodBasedBoard"] = "WoodBasedBoard";
    MaterialTypeEnum["MineralBondedBoards"] = "MineralBondedBoards";
    MaterialTypeEnum["Metal"] = "Metal";
    MaterialTypeEnum["Glazing"] = "Glazing";
    MaterialTypeEnum["Membrane"] = "Membrane";
    MaterialTypeEnum["FoamMaterials"] = "FoamMaterials";
    MaterialTypeEnum["AcousticTreatmentMaterials"] = "AcousticTreatmentMaterials";
    MaterialTypeEnum["AirGap"] = "AirGap";
    MaterialTypeEnum["Link"] = "Link";
    MaterialTypeEnum["Filler"] = "Filler";
    MaterialTypeEnum["Heavy"] = "Heavy";
    MaterialTypeEnum["Board"] = "Board";
    MaterialTypeEnum["ZPanel"] = "ZPanel";
})(MaterialTypeEnum || (MaterialTypeEnum = {}));
export var RuMaterialTypeEnum;
(function (RuMaterialTypeEnum) {
    RuMaterialTypeEnum["MasonryAndSolid"] = "\u041A\u0438\u0440\u043F\u0438\u0447\u043D\u044B\u0435 \u0438 \u043C\u043E\u043D\u043E\u043B\u0438\u0442\u043D\u044B\u0435";
    RuMaterialTypeEnum["Frame"] = "\u041A\u0430\u0440\u043A\u0430\u0441\u043D\u044B\u0435";
    RuMaterialTypeEnum["PorousMaterials"] = "\u041F\u043E\u0440\u0438\u0441\u0442\u044B\u0435 \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u044B";
    RuMaterialTypeEnum["SandwichPanel"] = "\u0421\u044D\u043D\u0434\u0432\u0438\u0447-\u043F\u0430\u043D\u0435\u043B\u0438";
    RuMaterialTypeEnum["GypsumBondedbBoards"] = "\u0413\u0438\u043F\u0441\u043E\u043A\u0430\u0440\u0442\u043E\u043D\u043D\u044B\u0435";
    RuMaterialTypeEnum["WoodBasedBoard"] = "\u0414\u0440\u0435\u0432\u0435\u0441\u043D\u043E-\u0441\u0442\u0440\u0443\u0436\u0435\u0447\u043D\u044B\u0435 \u043F\u043B\u0438\u0442\u044B";
    RuMaterialTypeEnum["MineralBondedBoards"] = "\u041C\u0438\u043D\u0435\u0440\u0430\u043B\u044C\u043D\u044B\u0435 \u043F\u043B\u0438\u0442\u044B";
    RuMaterialTypeEnum["Metal"] = "\u041C\u0435\u0442\u0430\u043B\u043B\u0438\u0447\u0435\u0441\u043A\u0438\u0435";
    RuMaterialTypeEnum["Glazing"] = "\u0421\u0442\u0435\u043A\u043B\u044F\u043D\u043D\u044B\u0435";
    RuMaterialTypeEnum["Membrane"] = "\u041C\u0435\u043C\u0431\u0440\u0430\u043D\u044B";
    RuMaterialTypeEnum["FoamMaterials"] = "\u041F\u0435\u043D\u043E\u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u044B";
    RuMaterialTypeEnum["AcousticTreatmentMaterials"] = "\u0410\u043A\u0443\u0441\u0442\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u044B";
    RuMaterialTypeEnum["AirGap"] = "\u0412\u043E\u0437\u0434\u0443\u0448\u043D\u044B\u0435 \u0437\u0430\u0437\u043E\u0440\u044B";
    RuMaterialTypeEnum["Link"] = "\u0421\u0432\u044F\u0437\u0443\u044E\u0449\u0438\u0435";
    RuMaterialTypeEnum["Filler"] = "\u041D\u0430\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0435";
    RuMaterialTypeEnum["Heavy"] = "\u0422\u044F\u0436\u0435\u043B\u044B\u0435";
    RuMaterialTypeEnum["Board"] = "\u041F\u043B\u0438\u0442\u044B";
})(RuMaterialTypeEnum || (RuMaterialTypeEnum = {}));
export var MaterialTypesSelectValuesEnum;
(function (MaterialTypesSelectValuesEnum) {
    MaterialTypesSelectValuesEnum["Base"] = "Base";
    MaterialTypesSelectValuesEnum["Facing"] = "Facing";
    MaterialTypesSelectValuesEnum["Soundproofing"] = "Soundproofing";
    // Additional = 'Additional',
    MaterialTypesSelectValuesEnum["FramePartition"] = "Frame Partition";
    MaterialTypesSelectValuesEnum["AirGapFiller"] = "AirGapFiller";
})(MaterialTypesSelectValuesEnum || (MaterialTypesSelectValuesEnum = {}));
export var MaterialTypesSelectValuesMap = (_a = {},
    _a[MaterialTypesSelectValuesEnum.Base] = [
        { label: 'Тяжелые', value: MaterialTypeEnum.Heavy },
        //доп материалы
        { label: 'Плиты', value: MaterialTypeEnum.Board },
        { label: 'Мембраны', value: MaterialTypeEnum.Membrane },
        { label: 'Акустические материалы', value: MaterialTypeEnum.AcousticTreatmentMaterials },
    ],
    _a[MaterialTypesSelectValuesEnum.Soundproofing] = [
        { label: 'Звукоизоляционные', value: MaterialTypeEnum.ZPanel },
        //доп материалы
        { label: 'Плиты', value: MaterialTypeEnum.Board },
        { label: 'Мембраны', value: MaterialTypeEnum.Membrane },
        { label: 'Акустические материалы', value: MaterialTypeEnum.AcousticTreatmentMaterials },
    ],
    _a[MaterialTypesSelectValuesEnum.Facing] = [
        { label: 'Каркасные', value: MaterialTypeEnum.Frame },
        { label: 'Воздушные зазоры', value: MaterialTypeEnum.AirGap },
        { label: 'Связующие', value: MaterialTypeEnum.Link },
        { label: 'Наполнительные', value: MaterialTypeEnum.Filler },
        { label: 'Плиты', value: MaterialTypeEnum.Board },
        //доп материалы
        { label: 'Мембраны', value: MaterialTypeEnum.Membrane },
        { label: 'Акустические материалы', value: MaterialTypeEnum.AcousticTreatmentMaterials },
    ],
    // [MaterialTypesSelectValuesEnum.Additional]: [
    // 	{ label: 'Плиты', value: MaterialTypeEnum.Board },
    // 	{ label: 'Мембраны', value: MaterialTypeEnum.Membrane },
    // 	{ label: 'Акустические материалы', value: MaterialTypeEnum.AcousticTreatmentMaterials },
    // ],
    _a[MaterialTypesSelectValuesEnum.FramePartition] = [
        { label: 'Каркасные', value: MaterialTypeEnum.Frame },
        { label: 'Наполнительные', value: MaterialTypeEnum.Filler },
        { label: 'Плиты', value: MaterialTypeEnum.Board },
        //доп материалы
        { label: 'Мембраны', value: MaterialTypeEnum.Membrane },
        { label: 'Акустические материалы', value: MaterialTypeEnum.AcousticTreatmentMaterials },
    ],
    _a[MaterialTypesSelectValuesEnum.AirGapFiller] = [
        { label: 'Воздушные зазоры', value: MaterialTypeEnum.AirGap },
        { label: 'Наполнительные', value: MaterialTypeEnum.Filler },
        //доп материалы
        { label: 'Плиты', value: MaterialTypeEnum.Board },
        { label: 'Мембраны', value: MaterialTypeEnum.Membrane },
        { label: 'Акустические материалы', value: MaterialTypeEnum.AcousticTreatmentMaterials },
    ],
    _a);
export var RuMaterialTypesSelectValues = [
    { label: 'Кирпичные и монолитные', value: MaterialTypeEnum.MasonryAndSolid },
    { label: 'Каркасные', value: MaterialTypeEnum.Frame },
    { label: 'Пористые материалы', value: MaterialTypeEnum.PorousMaterials },
    { label: 'Сэндвич-панели', value: MaterialTypeEnum.SandwichPanel },
    { label: 'Гипсокартонные', value: MaterialTypeEnum.GypsumBondedbBoards },
    { label: 'Древесно-стружечные плиты', value: MaterialTypeEnum.WoodBasedBoard },
    { label: 'Минеральные плиты', value: MaterialTypeEnum.MineralBondedBoards },
    { label: 'Металлические', value: MaterialTypeEnum.Metal },
    { label: 'Стеклянные', value: MaterialTypeEnum.Glazing },
    { label: 'Мембраны', value: MaterialTypeEnum.Membrane },
    { label: 'Пеноматериалы', value: MaterialTypeEnum.FoamMaterials },
    { label: 'Акустические материалы', value: MaterialTypeEnum.AcousticTreatmentMaterials },
    { label: 'Воздушные зазоры', value: MaterialTypeEnum.AirGap },
    { label: 'Связующие', value: MaterialTypeEnum.Link },
    { label: 'Наполнительные', value: MaterialTypeEnum.Filler },
    { label: 'Тяжелые', value: MaterialTypeEnum.Heavy },
    { label: 'Плиты', value: MaterialTypeEnum.Board },
    { label: 'Звукоизоляционные', value: MaterialTypeEnum.ZPanel },
];
